import {
  PALLET_TYPES,
  getPalletFootprintMetres,
  getPalletTypeLabel,
} from '../../constants/pallets';

export const CURRENCY = [
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'USD',
    value: 'USD',
  },
];

const formatPalletSize = (palletType: string) => {
  const footprint = getPalletFootprintMetres(palletType);
  return footprint ? `${footprint.lengthM}m × ${footprint.widthM}m` : '';
};

export const PALLET_OPTIONS = PALLET_TYPES.map((type) => ({
  value: type.value,
  label: getPalletTypeLabel(type.value),
  size: formatPalletSize(type.value),
}));

export const SKU_UNITS = [
  {
    label: 'Item',
    value: 'Item',
  },
  {
    label: 'Case',
    value: 'Case',
  },
  {
    label: 'Pallet',
    value: 'Pallet',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const WEIGHT_UNITS = [
  {
    label: 'g',
    value: 'g',
  },
  {
    label: 'Kg',
    value: 'Kg',
  },
  {
    label: 'oz',
    value: 'oz',
  },
  {
    label: 'lb',
    value: 'lb',
  },
];

export const PALLET_WEIGHT_UNITS = [
  {
    label: 'Kg',
    value: 'Kg',
  },
  {
    label: 'lb',
    value: 'lb',
  },
];

export const VOLUME_UNITS = [
  {
    label: 'l',
    value: 'l',
  },
  {
    label: 'ml',
    value: 'ml',
  },
  {
    label: 'Kg',
    value: 'Kg',
  },
];

export const DIMENSION_UNITS = [
  {
    label: 'mm',
    value: 'mm',
  },
  {
    label: 'cm',
    value: 'cm',
  },
  {
    label: 'dm',
    value: 'dm',
  },
  {
    label: 'm',
    value: 'm',
  },
];

export const SKU_TEMPERATURE_CONTROL_TYPES = [
  {
    label: 'Ambient',
    value: 'Ambient',
  },
  {
    label: 'Chilled',
    value: 'Chilled',
  },
  {
    label: 'Frozen',
    value: 'Frozen',
  },
];

export const SKU_TEMPERATURE_UNITS = [
  {
    label: 'C',
    value: 'C',
  },
];
